module.exports = ".margin-top{\r\n    margin-top: 24px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-grid/variable-deduction-grid.component.css
// module id = ./src/app/hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-grid/variable-deduction-grid.component.css
// module chunks = main